// @flow

// Selectors
import { jobs$ } from 'hfty-soil-jobs'
import { farms$, fields$ } from 'fc-assets'
import tableState$ from './selectors/tableState'

// DataTable Compose
import composeSoilDataTable from 'hfty-datatable-soil-jobs'

export default composeSoilDataTable({
  jobs$,
  farms$,
  fields$,
  tableState$,
})
